import React, { useState } from 'react';
import './Card.css';

const voucherCount = [0, 5, 10, 15, 20, 25]

export const Card = ({ BGColorClass = 'BG-default', cardBorder = 'cardBorder-default', handleAddToCart, data }) => {

    const [planSummary, setPlanSummary] = useState(null);
    const [selectedVoucher, setSelectedVoucher] = useState("");
    const [buttonName, setButtonName] = useState("Add To Cart");

    // Function to handle the change in selection
    const handleSelectionChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedVoucher(selectedValue);
        let myPlanSummary = {
            planName: data.subscriptionPlanName,
            voucherCount:parseInt(selectedValue),
            planPrice: data.subscriptionPriceWithTax,
            planID: data.subscriptionPlanID
        }
        let cart = []
        cart.push(myPlanSummary);
        setPlanSummary(myPlanSummary);

    };

    return (<>
        { data !==null  &&
            <div className="col-lg-4 col-md-6 mb-3">
                <div className={`friendsFamily custom-column1 ${cardBorder}`}>
                    <div className="row " style={{ height: '56px', paddingTop: '10px' }}>
                        <div className="col-6 align-items-start justify-content-center d-flex flex-column">
                            <div className="product-price" style={{ lineHeight: '20px' }}>
                                <span className="prise-gr">₹{data.subscriptionPriceWithTax}</span><span className="month">/month</span>
                            </div>
                            {
                                data.discount > 0 ? <div className="watcho-prs">
                                    {data.discount > 0 && <span style={{ textDecoration: 'line-through' }}> ₹{data.subscriptionDisplayPriceWithTax}  </span>}
                                </div> : null  
                            }
                            
                        </div>
                        <div className={`col-6 align-items-end justify-content-start d-flex flex-column`}>
                            <div className="product-info">

                                <div className={`my-class-aditional ${BGColorClass}`}>Additional 50%</div>

                                <span className="product-tit">{data.subscriptionPlanName}</span>
                            </div>
                            <div className="aed-curr">
                                <span >  {`₹${data.subscriptionPriceWithOutTax} + Tax = ₹ ${data.subscriptionPriceWithTax}`} </span>
                            </div>
                        </div>
                    </div>
                    

                    <div className=" my-goes mt-4 text-center">
                        <h3>{data.subscriptionPlanDescription}</h3>
                        <p>The Smartest Choice You'll Make </p>
                    </div>

                    <div className="image-grid">
                        {data && data.subscriptionApps && data.subscriptionApps.length > 0 && data.subscriptionApps.map((imgData, idx) => (
                            <div key={idx} className="image-item"><img src={imgData.appIconUrl} alt={imgData.appName} /></div>
                            ))}
                    </div>

                    <div className="bottom-margin">
                        <div className="button-container">
                            <select className="voucher-dropdown" value={selectedVoucher} onChange={handleSelectionChange}>
                                {voucherCount.map((data, idx) =>
                                    <option key={idx} value={data} >{data} </option>
                                )}
                            </select>

                            <button className="custom-button btn-60 add-to-cart-btn" onClick={(e) => handleAddToCart(e, planSummary, setButtonName)}>
                                <span className="csrt-yo-btn" >{buttonName}</span>
                            </button>
                        </div>

                        <div><p className="voucher">Vouchers</p></div>
                    </div>
                     
                </div>
            </div>
        }
    </>
    );
}
